var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    transform: "translate(-1640 -409)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45923",
    "data-name": "Rectangle 45923",
    width: 35,
    height: 35,
    rx: 7,
    transform: "translate(1640 409)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_270264",
    "data-name": "Group 270264",
    transform: "translate(1643 412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497818",
    "data-name": "Path 497818",
    d: "M17.062,12.02l.92.92L8.92,22H8v-.92l9.061-9.06M20.662,6a1,1,0,0,0-.7.29l-1.83,1.83,3.751,3.75,1.83-1.83a1,1,0,0,0,0-1.41l-2.34-2.34A.982.982,0,0,0,20.662,6Zm-3.6,3.19L6,20.25V24H9.751L20.812,12.94Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497819",
    "data-name": "Path 497819",
    d: "M0,0H30V30H0Z",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.916954cce08d66a734cbf260cf89d3f3.svg";
export { ForwardRef as ReactComponent };